var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAssignIcon = function SvgAssignIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 4.124C3 3.504 3.503 3 4.124 3h11.912c.62 0 1.124.503 1.124 1.124v3.863L7.997 17.15H4.124c-.62 0-1.124-.503-1.124-1.124V4.124ZM5.008 9.45a.45.45 0 0 1 .45-.45h5.81a.45.45 0 0 1 .449.45v1.1a.45.45 0 0 1-.45.45h-5.81a.45.45 0 0 1-.45-.45v-1.1ZM5.458 5a.45.45 0 0 0-.45.45v1.1c0 .249.201.45.45.45l7.092-.05A.45.45 0 0 0 13 6.5V5.399a.45.45 0 0 0-.45-.45L5.457 5Z",
    fill: "#797CDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.815 12.064a.646.646 0 0 0 0-.904l-1.493-1.472a.652.652 0 0 0-.908 0l-1.185 1.165 2.416 2.407 1.17-1.196ZM9.512 18.55a.2.2 0 0 0-.059.142V20.8c0 .11.09.2.2.2h2.119a.2.2 0 0 0 .141-.058l6.895-6.866a.2.2 0 0 0 0-.284l-2.117-2.108a.2.2 0 0 0-.283 0L9.512 18.55Z",
    fill: "#797CDB"
  })));
};
export default SvgAssignIcon;